import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cms_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('cms_token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Public APIs
export const getWebsiteContent = () => api.get('/content');
export const submitQuote = (data) => api.post('/quotes', data);

// Auth APIs
export const login = (credentials) => api.post('/cms/login', credentials);
export const getCurrentUser = () => api.get('/cms/me');
export const changePassword = (data) => api.post('/cms/change-password', data);

// User Management APIs
export const getUsers = () => api.get('/cms/users');
export const createUser = (data) => api.post('/cms/users', data);
export const updateUser = (id, data) => api.put(`/cms/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/cms/users/${id}`);
export const resetUserPassword = (id) => api.post(`/cms/users/${id}/reset-password`);

// Quote APIs
export const getQuotes = () => api.get('/cms/quotes');
export const updateQuote = (id, data) => api.patch(`/cms/quotes/${id}`, data);
export const deleteQuote = (id) => api.delete(`/cms/quotes/${id}`);

// Company APIs
export const getCompanyInfo = () => api.get('/cms/company');
export const updateCompanyInfo = (data) => api.put('/cms/company', data);

// Service APIs
export const getServices = () => api.get('/cms/services');
export const createService = (data) => api.post('/cms/services', data);
export const updateService = (id, data) => api.put(`/cms/services/${id}`, data);
export const deleteService = (id) => api.delete(`/cms/services/${id}`);

// Project APIs
export const getProjects = () => api.get('/cms/projects');
export const createProject = (data) => api.post('/cms/projects', data);
export const updateProject = (id, data) => api.put(`/cms/projects/${id}`, data);
export const deleteProject = (id) => api.delete(`/cms/projects/${id}`);

// Testimonial APIs
export const getTestimonials = () => api.get('/cms/testimonials');
export const createTestimonial = (data) => api.post('/cms/testimonials', data);
export const updateTestimonial = (id, data) => api.put(`/cms/testimonials/${id}`, data);
export const deleteTestimonial = (id) => api.delete(`/cms/testimonials/${id}`);

// Service Area APIs
export const getServiceAreas = () => api.get('/cms/service-areas');
export const createServiceArea = (data) => api.post('/cms/service-areas', data);
export const updateServiceArea = (id, data) => api.put(`/cms/service-areas/${id}`, data);
export const deleteServiceArea = (id) => api.delete(`/cms/service-areas/${id}`);

// Article APIs (Public)
export const getArticles = () => api.get('/articles');
export const getArticleBySlug = (slug) => api.get(`/articles/${slug}`);

// Article APIs (CMS)
export const getCmsArticles = () => api.get('/cms/articles');
export const createArticle = (data) => api.post('/cms/articles', data);
export const updateArticle = (id, data) => api.put(`/cms/articles/${id}`, data);
export const deleteArticle = (id) => api.delete(`/cms/articles/${id}`);

export default api;
